import { isDateAllowedOnTimetable } from '@chirp/access-verification';
import { PropertyFragment } from '../../apollo';

export function getIsLeasingOfficeClosed(property?: PropertyFragment | null) {
  const propertyVirtualDirectory = property?.propertyVirtualDirectory;
  const leasingOfficeHours = propertyVirtualDirectory?.leasingOfficeHours;
  const timezone = property?.timezone;

  return (
    !!leasingOfficeHours &&
    !!timezone &&
    !isDateAllowedOnTimetable(new Date(), leasingOfficeHours, timezone)
  );
}
